module.exports = __webpack_public_path__ + "img/ticket-right.febc7172.png";